import { atom } from 'recoil'

export default atom({
  key: 'images',
  default: [],
})
